import {
  afterRender,
  AfterViewChecked,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  PLATFORM_ID,
  signal,
  viewChild,
  WritableSignal
} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {TopFilterFacetComponent} from '../top-filter-facet/top-filter-facet.component';
import {AlgoliaFacetFilter} from '@core/types/algolia-filter';
import {SearchPageComponent} from '@modules/page/components/search-page/search-page.component';
import {HEADER_HEIGHT} from '@core/utils/HeaderHeight';
import {GridService} from '@core/services/grid.service';
import {TrackEventService} from '@core/services/track-event.service';

@Component({
  selector: 'app-desktop-top-filter',
  templateUrl: './desktop-top-filter.component.html',
  styleUrls: ['./desktop-top-filter.component.scss'],
  imports: [TopFilterFacetComponent]
})
export class DesktopTopFilterComponent implements AfterViewChecked {
  protected gridService = inject(GridService);
  protected searchPage = inject(SearchPageComponent);
  private platformId = inject(PLATFORM_ID);
  private trackEventService = inject(TrackEventService);


  readonly topFilterFacets = viewChild<ElementRef<HTMLDivElement>>('topFilterFacets');

  readonly shownFilters = input<AlgoliaFacetFilter[]>();
  selectedAttribute: string | null;
  hideExtraFilters = signal(true);
  initFilterInProgress = signal(true)
  scrollIntoView: any;
  filtersHidden: WritableSignal<{ key: string, value: boolean }[]> = signal([]);
  hasLoadedHits = input(false);

  showMoreFilter = computed(() => this.hideExtraFilters() && this.filtersHidden().find(filter => filter.value))

  constructor() {
    if (isPlatformBrowser(this.platformId) && this.initFilterInProgress()) {
      this.initFilterInProgress.set(false);
    }

    afterRender({
      read: () => {
        this.searchPage.topFilterHeightChange(this.getTopFilterHeight());
      }
    },)
  }
  protected getTopFilterHeight() {
    if (!isPlatformBrowser(this.platformId)) {
      return '52px';
    }
    const offsetHeight = this.topFilterFacets()?.nativeElement?.offsetHeight;
    if (offsetHeight === undefined) {
      return '14px';
    }
    if (!this.gridService.isLargeSignal()) {
      return (offsetHeight + 8 + HEADER_HEIGHT) + 'px';
    }
    return (offsetHeight + 16) + 'px';
  }

  ngAfterViewChecked() {
    if (this.scrollIntoView) {
      (this.scrollIntoView as any).elRef.nativeElement.scrollIntoView();
      this.scrollIntoView = null;
    }
  }

  hideFilter(hide: boolean, facet: string) {
    const filtersHidden = this.filtersHidden();
    const filter = filtersHidden.find(filter => filter.key === facet) ?? {key: facet, value: false};
    filter.value = hide;
    this.filtersHidden.set([...filtersHidden.filter(filter => filter.key !== facet), filter]);
  }

  setSelectedAttribute(attr: string, filterFacet: TopFilterFacetComponent) {
    if (this.selectedAttribute === attr) {
      this.selectedAttribute = null;
      return;
    }
    this.selectedAttribute = attr;
    this.scrollIntoView = filterFacet;
  }

  toggleFilters() {
    this.hideExtraFilters.update(d => !d);
    this.trackEventService.trackClickEvent('show-more-filters', {showExtraFilters: !this.hideExtraFilters()});
  }
}
